import { render, staticRenderFns } from "./_ToolbarItem.vue?vue&type=template&id=3ecd7aba&scoped=true&"
import script from "./_ToolbarItem.vue?vue&type=script&lang=js&"
export * from "./_ToolbarItem.vue?vue&type=script&lang=js&"
import style0 from "./_ToolbarItem.vue?vue&type=style&index=0&id=3ecd7aba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecd7aba",
  null
  
)

export default component.exports